import React from "react";
import "./PalmSoyabeanOilConveyorChain.css";
import palmimg from "./Palm.jpg";

const PalmSoyabeanOilConveyorChain = () => {
  return (
    <div className="main-palm">
      <div className="second-palm">
        <div className="palm">
          <p>Palm Soyabean Oil Conveyor Chain</p>
          <div>
            <p className="pal2">
              Swajit Engineering Pvt.Ltd.> Palm Soyabean Oil Conveyor Chain
            </p>
          </div>
        </div>
        <div className="soyabean">
          <h1 className="oil">
            Palm and Soyabean Oil Conveyor Chain Manufacturers in India
          </h1>
          <p>
            We at Swajit engineering Pvt ltd are leading one of <b> palm and
            soyabean oil conveyor chain Manufacturers in Aurangabad, Maharashtra
            India.</b> Enriched by ultra-modern technology, we offer a wide variety
            of chains for the palm and soyabean oil industry at a reasonable
            rate. Such chains include metal forged chains, side plate chains,
            offset link chains, hollow pin chains, and some other chain
            attachments.
          </p>

          <div className="palm-chain">
            <img src={palmimg} alt="img"></img>

            <div className="palm-chain1">
              <div className="palm-chain2">
                <p>
                  We are providing a huge range of roller chains and bushed
                  chains that come with quality features and specifications for
                  the palm oil industry. These chains are made up of superior
                  quality stainless steel and alloy steel materials. To cater to
                  the demands of the working environment, we manufacture these
                  chains with special components that ensure high tensile
                  strength and longer service life. Our offered range of offset
                  pin chains is used to transfer materials in the palm oil
                  industry. Due to this reason, our company has become the most
                  popular <b>palm and soyabean oil conveyor chain manufacturers in
                  India.</b>
                </p>
                <h3>Key features:</h3>
                <ul>
                  <li>Sturdy construction</li>
                  <li> Flexible and portable</li>
                  <li>Costs effective</li>
                  <li>Easy to clean and maintain</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="palm-chain3">
            
            <p>Contact us on 9922941689 or Email marketing@swajit.com.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PalmSoyabeanOilConveyorChain;
